@if (isOpen()) {
    <div class="modal z-\[900\] modal-open" (click)="onBackdropClick($event)" (keydown.escape)="onCancel()" tabindex="-1">
        <div class="modal-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
            <h3 class="font-bold text-lg">{{ title() }}</h3>
            <p class="py-4">{{ message() }}</p>
            <div class="modal-action">
                <button class="btn" [class]="cancelBtnClass()" [disabled]="isLoading()" (click)="onCancel()">
                    {{ cancelBtnLabel() }}
                </button>
                <button class="btn" [class]="confirmBtnClass()" [disabled]="isLoading()" (click)="onConfirm()">
                    @if (isLoading()) {
                        <span class="loading loading-spinner"></span>
                    }
                    {{ confirmBtnLabel() }}
                </button>
            </div>
        </div>
    </div>
}
